import { Component, Input, OnChanges } from '@angular/core';
import type { DateRange } from 'moment-range';

import { ChartShowModes, Form } from '@site-mate/dashpivot-shared-library';

import { ChartColorScheme } from 'app/shared/model/charts/chart-color-scheme.model';
import { ChartSettings } from 'app/shared/model/charts/chart-settings.model';
import { ChartData } from 'app/shared/model/charts/ratio/chart-data.model';
import { DateRangeFormatters } from 'app/shared/model/charts/ratio/date-range-formatters.model';
import { RatioChartDataParserService } from 'app/shared/service/ratio-chart-data-parser.service';

@Component({
  selector: 'cc-ratio-chart',
  templateUrl: './ratio-chart.component.html',
  styleUrls: ['./ratio-chart.component.scss'],
})
export class RatioChartComponent implements OnChanges {
  readonly chartShowModes = ChartShowModes;
  readonly chartColorScheme = ChartColorScheme;
  readonly dateRangeFormatters = DateRangeFormatters;
  readonly maxLabelLength = 20;

  @Input() loading: boolean;
  @Input() chart: ChartSettings;
  @Input() forms: Form[] = [];
  @Input() dateRange: DateRange;

  data: ChartData[] = [];

  constructor(private readonly ratioChartDataParserService: RatioChartDataParserService) {}

  ngOnChanges() {
    if (this.loading) {
      return;
    }
    const { data } = this.ratioChartDataParserService.parse(this.forms, this.chart);
    this.data = data;
  }

  getPercentage(quantity: number, total: number) {
    const decimalPlaces = 2;
    return ((quantity / total) * 100).toFixed(decimalPlaces);
  }
}
